<nav class="navbar bg-primary text-white navbar-expand-lg d-none d-lg-flex px-3">
  <a
    class="navbar-brand py-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate: { fgbdefault: 'Move to home page' } }}"
  >
    <label id="homeLink" class="accessibility-only">Go To Home Page</label>
    <img
      *notInPopulation="[population.Kids]"
      alt=""
      class="ms-1 h-100"
      aria-labelledby="homeLink"
      src="assets/images/nav-logo.png"
      draggable="false"
    />
    <img
      *inPopulation="[population.Kids]"
      alt=""
      class="ms-1 h-100"
      aria-labelledby="homeLink"
      src="assets/images/kids/kids-logo.png"
      alt=""
      draggable="false"
    />
  </a>
  <!-- Left Side Content -->
  <div class="nav-container">
    <ul class="navbar-nav">
      <li class="nav-item active">
        <a
          class="nav-link mx-1"
          [routerLink]="['/rewards/marketplace']"
          routerLinkActive="router-link-active"
          attr.aria-label="{{ 'nav.rewards.screenreader' | translate: { fgbdefault: 'Move to rewards page' } }}"
          >{{ 'nav.rewards' | translate }}</a
        >
      </li>

      <li class="nav-item active">
        <a
          class="nav-link mx-1"
          [routerLink]="['/games']"
          routerLinkActive="router-link-active"
          attr.aria-label="{{ 'nav.games.screenreader' | translate: { fgbdefault: 'Move to games page' } }}"
          >{{ 'nav.games' | translate }}</a
        >
      </li>
      <li class="nav-item active">
        <a
          class="nav-link mx-1"
          [routerLink]="['/challenges']"
          routerLinkActive="router-link-active"
          attr.aria-label="{{ 'nav.challenges.screenreader' | translate: { fgbdefault: 'Move to challenge page' } }}"
          >{{ 'nav.challenges' | translate }}</a
        >
      </li>

      <ng-container *notInPopulation="[population.Kids]">
        <li class="nav-item active">
          <a
            class="nav-link mx-1"
            [routerLink]="['/guardians']"
            routerLinkActive="router-link-active"
            attr.aria-label="{{ 'nav.kids.screenreader' | translate: { fgbdefault: 'Move to kids page' } }}"
            >{{ 'nav.kids' | translate }}</a
          >
        </li>
      </ng-container>

      <ng-container *inPopulation="[population.Kids]">
        <li class="nav-item active">
          <a
            class="nav-link mx-1"
            [routerLink]="['/worksheets']"
            routerLinkActive="router-link-active"
            attr.aria-label="{{ 'nav.challenges.screenreader' | translate: { fgbdefault: 'Move to worksheets page' } }}"
            >{{ 'nav.worksheets' | translate }}</a
          >
        </li>

        <li class="nav-item active">
          <a
            class="nav-link mx-1"
            [routerLink]="['/earn']"
            routerLinkActive="router-link-active"
            attr.aria-label="{{ 'nav.challenges.screenreader' | translate: { fgbdefault: 'Move to earn points page' } }}"
            >{{ 'nav.earn' | translate }}</a
          >
        </li>
      </ng-container>
    </ul>
  </div>
  <!-- Right Side Content -->
  <div class="right-side-container d-flex align-items-center flex-nowrap my-2 my-lg-0">
    <div class="balance font-size-14 ps-0">
      <div class="d-flex align-items-center" *ngIf="loyaltyPointsCard$">
        <span class="icon material-icons currency-icons me-2">loyalty</span>
        <div class="d-flex align-items-center fw-bold">
          <h5 class="mb-0 me-1">{{ loyaltyPointsCard$ | async }}</h5>
          <div class="me-1 currency-pts">{{ 'fgbcl.currency.pts' | translate }}</div>
        </div>
      </div>
    </div>
    <!--eCash-->
    <ng-container *notInPopulation="[population.Kids]">
      <div class="balance font-size-14 ps-0">
        <div class="d-flex align-items-center" *ngIf="combinedCard$">
          <span
            class="icon material-icons currency-icons me-2 money-bag-icon material-symbols-outlined"
            role="img"
            attr.aria-label="{{ 'nav.ecash.screenreader' | translate }}"
            >money_bag</span
          >
          <span class="fw-bold">{{ combinedCard$ | async | FortressCurrencyPipe }}</span>
        </div>
      </div>
    </ng-container>

    <!--Notifications-->
    <fgb-notification-button></fgb-notification-button>
    <!-- button toggle right menu -->

    <button
      class="btn btn-primary nav-hamburger"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasRight"
      aria-controls="offcanvasRight"
    >
      <span class="icon material-icons"> menu </span>
    </button>
  </div>
</nav>
<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header bg-primary pb-0">
    <img class="logo" [height]="48" [width]="48" src="assets/images/nav-logo.png" alt="" draggable="false" />
    <button type="button" class="text-white nav-close-button" data-bs-dismiss="offcanvas" aria-label="Close">
      <span class="icon material-icons">close</span>
    </button>
  </div>
  <div class="offcanvas-body position-relative">
    <fgb-member-card [showLogo]="false" [isNav]="true"></fgb-member-card>
    <div class="right-nav-menu-container mt-4">
      <ul class="navbar-nav popout-nav" #greedyNav>
        <!--Account Page-->
        <ng-container *notInPopulation="[population.Kids]">
          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/account']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'account.nav.account.screenreader' | translate: { fgbdefault: 'Move to Account page' } }}"
            >
              <label>{{ 'nav.account' | translate }}</label>
            </a>
          </li>
        </ng-container>

        <!--Activity Page-->
        <ng-container *inPopulation="[population.Kids]">
          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/activity']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'account.nav.activity.screenreader' | translate: { fgbdefault: 'Move to activity page' } }}"
            >
              <label>{{ 'nav.activity' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/rewards/marketplace']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'account.nav.rewards.screenreader' | translate: { fgbdefault: 'Move to rewards page' } }}"
            >
              <label>{{ 'nav.rewards' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/rewards/wallet']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'account.nav.wallet.screenreader' | translate: { fgbdefault: 'Move to wallet page' } }}"
            >
              <label>{{ 'nav.wallet' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/challenges']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'account.nav.challenges.screenreader' | translate: { fgbdefault: 'Move to challenges page' } }}"
            >
              <label>{{ 'nav.challenges' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/games']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'account.nav.games.screenreader' | translate: { fgbdefault: 'Move to games page' } }}"
            >
              <label>{{ 'nav.games' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/earn']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'account.nav.earn.screenreader' | translate: { fgbdefault: 'Move to earn page' } }}"
            >
              <label>{{ 'nav.earn' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/gallery']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.gallery.screenreader' | translate: { fgbdefault: 'Move to gallery page' } }}"
            >
              <label>{{ 'nav.gallery' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/worksheets']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.worksheets.screenreader' | translate: { fgbdefault: 'Move to worksheets page' } }}"
            >
              <label>{{ 'nav.worksheets' | translate }}</label>
            </a>
          </li>
        </ng-container>

        <!--My Membership-->
        <ng-container *notInPopulation="[population.Kids]">
          <!--Hawks Bucks-->
          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/hawksbucks']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.hawksbucks.screenreader' | translate: { fgbdefault: 'Move to hawksbucks page' } }}"
            >
              <label>{{ 'nav.hawksbucks' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/rewards/wallet']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.wallet.screenreader' | translate: { fgbdefault: 'Move to wallet page' } }}"
            >
              <label>{{ 'nav.wallet' | translate }}</label>
            </a>
          </li>

          <li class="nav-item active">
            <a
              href="{{ 'nav.membership.url' | translate }}"
              target="_blank"
              attr.aria-label="{{ 'nav.membership.screenreader' | translate: { fgbdefault: 'Move to membership page' } }}"
            >
              <label>{{ 'nav.membership' | translate }}</label>
            </a>
          </li>

          <!--Squawk Squad-->
          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/guardians']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.guardians.screenreader' | translate: { fgbdefault: 'Move to squawk squad page' } }}"
            >
              <label>{{ 'nav.kids' | translate }}</label>
            </a>
          </li>

          <!--Hawks Pay-->
          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/payment']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.payment.screenreader' | translate: { fgbdefault: 'Move to hawks pay page' } }}"
            >
              <label>{{ 'nav.payment' | translate }}</label>
            </a>
          </li>
        </ng-container>

        <!--FAQs-->
        <li class="nav-item active">
          <a
            data-bs-dismiss="offcanvas"
            [routerLink]="['/faq']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            attr.aria-label="{{ 'nav.faq.screenreader' | translate: { fgbdefault: 'Move to fag page' } }}"
          >
            <label>{{ 'nav.faq' | translate }}</label>
          </a>
        </li>

        <!--Terms-->
        <ng-container *inPopulation="[population.Kids]">
          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/terms']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.terms.screenreader' | translate: { fgbdefault: 'Move to terms page' } }}"
            >
              <label>{{ 'nav.terms' | translate }}</label>
            </a>
          </li>
        </ng-container>

        <!--Earn Points-->
        <ng-container *notInPopulation="[population.Kids]">
          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/earn']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.earn.screenreader' | translate: { fgbdefault: 'Move to earn page' } }}"
            >
              <label>{{ 'nav.earn' | translate }}</label>
            </a>
          </li>
          
          <!--My Renewals-->
          <li class="nav-item active">
            <a
              data-bs-dismiss="offcanvas"
              [routerLink]="['/my-renewals']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              attr.aria-label="{{ 'nav.renewals.screenreader' | translate: { fgbdefault: 'Move to My Renewals' } }}"
            >
              <label>{{ 'nav.renewals' | translate }}</label>
            </a>
          </li>

          <!--Hawks Shop-->
          <li class="nav-item active">
            <a
              href="{{ 'nav.shop.url' | translate }}"
              target="_blank"
              attr.aria-label="{{ 'nav.membership.screenreader' | translate: { fgbdefault: 'Move to shop page' } }}"
            >
              <label>{{ 'nav.shop' | translate }}</label>
            </a>
          </li>

          <!--Contact-->
          <li class="nav-item active">
            <a
              href="{{ 'nav.contact.url' | translate }}"
              target="_blank"
              attr.aria-label="{{ 'nav.contact.us.screenreader' | translate: { fgbdefault: 'Move to contact us page' } }}"
            >
              <label>{{ 'nav.contact.us' | translate }}</label>
            </a>
          </li>

          <li class="nav-item btn-logout align-items-center">
            <a class="d-flex align-items-center" (click)="logout()">
              <span class="icon material-icons">logout</span>
              <label class="mb-0 ms-2">{{ 'nav.log.out' | translate }}</label>
            </a>
          </li>
        </ng-container>

        <ng-container *inPopulation="[population.Kids]">
          <div class="back-to-guardian">
            <fgb-back-to-guardian></fgb-back-to-guardian>
          </div>
        </ng-container>
      </ul>
    </div>
  </div>
</div>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>
